import Dashboard from "../../(Admin) dashboard/index.js";
import EmployeesTable from "../../(admin)employeemanagement";
import Reports from "../../(Admin) Reports/Reports.js";
import Analytics from "../../(All) ComingSoon/ComingSoon.js";
import SettingsPage from "../../(All) settings/settings.js";
import Payroll from "../../(admin and manager) Payroll/index.jsx";
import Calendar from "../../(All) Calendar/index.jsx";
import Attendance from "../../(Admin)Attendance";
import Mo3tiAdminDocumentRequests from "../../(Admin)DocumentRequests/DocumentRequestsPage.jsx";
import ExcelSalaryProcessorWithTheme from "../../(Admin and Manager) Taxcalculator/index.jsx";
import Mo3tiAdvancementManagement from "../../(Admin)AdvancementManagement/AdvancementManagementPage.jsx";
import LeaveApprovalPage from "../../(Admin)leave_Managment/index.jsx";
import EmployeeActionsPage from "../../(Admin)EmployeeActions/EmployeeActionsPage.jsx";
import MessengerPage from "../../(All) messenger/MessengerPage.jsx";
import EscalationGroupMapping from "../../../pages/(Admin) Escalation group mapping/index.jsx";
import CompanyConfiguration from "../../(Admin)CompanyConfiguration";
import AdminLevelConfiguration from "../../(Admin) Level_Configuration";
import DepartmentsPage from "../../(Admin)Departments/index.jsx";
import { Settings } from "lucide-react";

export const renderDashboard = () => <Dashboard />;
export const renderEmployees = () => <EmployeesTable />;
export const renderPayroll = () => <Payroll />;
export const renderAttendance = () => <Attendance />;
export const renderAnalytics = () => <Analytics />;
export const renderReports = () => <Reports />;
export const renderMessages = () => <MessengerPage />;
export const renderEscalationGroupMapping = () => <EscalationGroupMapping />;
export const renderCalendar = () => <Calendar />;
export const renderSettings = () => <SettingsPage />;
export const renderMo3tiAdminDocumentRequests = () => <Mo3tiAdminDocumentRequests />;
export const renderMo3tiAdvancementManagement = () => <Mo3tiAdvancementManagement />;
export const renderAdminLeavePage = () => <LeaveApprovalPage />;
export const renderChangesPage = () => <EmployeeActionsPage />;
export const renderConfiguration = () => <CompanyConfiguration />;
export const renderAdminLevels = () => <AdminLevelConfiguration />;
export const renderDepartments = () => <DepartmentsPage />;
export const renderTaxCalculator = () => <ExcelSalaryProcessorWithTheme />;

// Placeholder renderer for under-development pages
export const renderOtherPage = (pageName, theme, t) => (
  <div>
    <div style={{ marginBottom: "32px" }}>
      <h1
        style={{
          color: theme === "light" ? "#0f172a" : "white",
          fontSize: "28px",
          fontWeight: "700",
        }}
      >
        {t[pageName] || pageName}
      </h1>
      <p
        style={{
          color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.8)",
        }}
      >
        {t.underDevelopment}
      </p>
    </div>
    <div
      style={{
        padding: "24px",
        background: theme === "light" ? "#fff" : "#1e293b",
        borderRadius: "16px",
        textAlign: "center",
      }}
    >
      <Settings size={64} />
      <h3 style={{ color: theme === "light" ? "#0f172a" : "white" }}>
        {t[pageName] || pageName} {t.pageName}
      </h3>
      <p
        style={{
          color: theme === "light" ? "#64748b" : "rgba(255,255,255,0.6)",
        }}
      >
        {t.effectiveManagement}
        <br />
        {pageName.toLowerCase()} {t.management}
      </p>
    </div>
  </div>
);